import axios from 'axios'

var url_register = process.env.REACT_APP_API_BASEURL  + "/api/register"
var url_create_customer = process.env.REACT_APP_API_BASEURL  + "/api/create-customer"
var url_tempPassword = process.env.REACT_APP_API_BASEURL  + "/api/tempPassword"
var url_changeOfPassword = process.env.REACT_APP_API_BASEURL  + "/api/changeOfPassword"
var url_sendCode = process.env.REACT_APP_API_BASEURL  + "/api/sendResetCode"
var url_verify = process.env.REACT_APP_API_BASEURL  + "/api/verify"
var url_google_signup = process.env.REACT_APP_API_BASEURL  + "/api/auth/google/signup"

// Create an account from a Google identity. Distinct from the sign-in call in
// SignInForm (/api/auth/google), which only accepts existing accounts.
//
// The terms fields are required by the backend — it refuses to create an
// account without a consent record, so they're captured the same way the
// password signup captures them.
export const googleSignup = ({ credential, acceptedTNC, timeTNCAccepted, acceptedTNCVersion, acceptedTNCFromIP }) => {
    return axios
        .post(url_google_signup, {
            credential,
            acceptedTNC,
            timeTNCAccepted,
            acceptedTNCVersion,
            acceptedTNCFromIP,
        }, { withCredentials: true })
        .then(res => res.data)
}

export const register = newUser => {

    console.log('user', newUser)
    console.log(newUser.acceptedTNCFromIP)
    return axios
    .post(url_register , {
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        email: newUser.email,
        password: newUser.password, 
        confirmEmail: newUser.confirmEmail,
        acceptedTNC: newUser.acceptedTNC,
        timeTNCAccepted: newUser.timeTNCAccepted,
        acceptedTNCVersion: newUser.acceptedTNCVersion,
        acceptedTNCFromIP: newUser.acceptedTNCFromIP
    })
    .then(res => {
        console.log('Registered!')

        axios.post(url_create_customer, {
         
              email: newUser.email,
          })
            .then((response) => {
               console.log('user added to database', response);
            })
    })
    .catch (err => {
        console.log('err', err)
        throw(err)
    })
}

export const verify = user => {
    return axios
    .post(url_verify, {
        email: user.email,
        secretToken: user.secretToken
    })
    .then(res => {
        console.log ("verification in progress.");
    })
    .catch (
        err => {
            throw(err)
        }
    )
}

export const sendCode = user => {
    return axios.post(url_sendCode, {
        email: user.email
    })
    .then(res => {
        console.log("Code Emailed.");
    })
    .catch (
        err => {
            throw(err)
        }
    )
}

export const temporaryPassword = user => {
    return axios
    .post(url_tempPassword, {
        email: user.email,
        tempPassword: user.tempPassword
    })
    .then(res => {
        console.log ("Temporary Password sent.");
    })
    .catch (
        err => {
            throw(err)
        }
    )
}


export const changeOfPassword = user => {
    return axios
    .post(url_changeOfPassword, {
        email: user.email,
        password: user.password,
        oldPassword: user.oldPassword
    })
    .then(res => {
        console.log ("Password now changed!");
    })
    .catch (
        err => {
            throw(err)
        }
    )
}
